/* Verdo header: sticky compact mode, mega/dropdown menus (hover, tap, keyboard, Esc), mobile drawer. */
if (!customElements.get('vc-header')) {
  customElements.define('vc-header', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.vc-header-section') || this;
      this.items = [...this.querySelectorAll('.vc-nav__item--mega, .vc-nav__item--drop')];
      const canHover = matchMedia('(hover: hover)').matches;
      this.items.forEach((item) => {
        const link = item.querySelector('.vc-nav__link');
        let t;
        if (canHover) {
          item.addEventListener('mouseenter', () => { clearTimeout(t); t = setTimeout(() => this.open(item), 90); });
          item.addEventListener('mouseleave', () => { clearTimeout(t); t = setTimeout(() => this.close(item), 140); });
        }
        // Tap or Enter opens the panel first; a second activation follows the link.
        link.addEventListener('click', (e) => {
          if (link.tagName === 'BUTTON') { item.classList.contains('is-open') ? this.close(item) : this.open(item); return; }
          if (!item.classList.contains('is-open')) { e.preventDefault(); this.open(item); }
        });
        // Keyboard: Tab moves between the top-level items without opening every panel on the way;
        // Space or Arrow Down opens one, then Tab walks into it.
        link.addEventListener('keydown', (e) => {
          if ((e.key === ' ' || e.key === 'ArrowDown') && !item.classList.contains('is-open')) { e.preventDefault(); this.open(item); }
        });
        item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) this.close(item); });
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.items.forEach((i) => { if (i.classList.contains('is-open')) { this.close(i); i.querySelector('.vc-nav__link').focus(); } }); });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.items.forEach((i) => this.close(i)); });
      // Compact sticky header. Compacting makes the header shorter. Chrome keeps the page still by moving
      // scrollY (scroll anchoring), but Safari has no scroll anchoring, so on iPhones everything under the
      // header jumped up by the height it lost. syncGap() gives the section a bottom margin equal to that
      // height, so the content below never moves in any browser. Two thresholds apart keep it from flickering.
      const COMPACT_AT = 200, EXPAND_AT = 60;
      const onScroll = () => {
        const was = this.section.classList.contains('is-compact');
        const compact = was ? window.scrollY > EXPAND_AT : window.scrollY > COMPACT_AT;
        if (compact !== was) {
          if (compact && !this.fullH) this.measureFull();
          this.section.classList.toggle('is-compact', compact);
          if (!compact) { this.section.classList.remove('search-open'); const t = this.querySelector('.vc-header__search-toggle'); t && t.setAttribute('aria-expanded', 'false'); }
          this.syncGap();
          this.items.forEach((i) => this.close(i));
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      // the full height changes with the width (rotation) and once the logo font arrives. iOS also fires
      // resize while its toolbar slides during a scroll; the width does not change then, so nothing is measured.
      let rz, lastW = window.innerWidth;
      window.addEventListener('resize', () => {
        if (window.innerWidth === lastW) return;
        lastW = window.innerWidth;
        cancelAnimationFrame(rz); rz = requestAnimationFrame(() => { this.measureFull(); this.syncGap(); });
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { this.measureFull(); this.syncGap(); });
      const burger = this.querySelector('.vc-header__burger');
      const drawer = document.getElementById('VcDrawer');
      if (burger && drawer) burger.addEventListener('click', () => drawer.open(burger));
      const st = this.querySelector('.vc-header__search-toggle');
      if (st) st.addEventListener('click', () => {
        const open = !this.section.classList.contains('search-open');
        this.section.classList.toggle('search-open', open);
        this.syncGap();
        st.setAttribute('aria-expanded', String(open));
        const i = this.querySelector('#VcSearchInput');
        if (open && i) i.focus();
      });
      // Escape in the header search closes the suggestions but keeps the words (a type=search field clears itself).
      const hsInput = this.querySelector('#VcSearchInput');
      const hsPs = hsInput && hsInput.closest('predictive-search');
      if (hsInput && hsPs) hsInput.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && hsPs.hasAttribute('open')) { e.preventDefault(); hsPs.close(); }
      });
    }
    /* height of the header when it is not compact, measured without a visible change (no paint in between) */
    measureFull() {
      const s = this.section, c = s.classList.contains('is-compact'), o = s.classList.contains('search-open');
      s.classList.remove('is-compact', 'search-open');
      this.fullH = s.offsetHeight;
      if (c) s.classList.add('is-compact');
      if (o) s.classList.add('search-open');
    }
    /* while compact, a bottom margin makes up the height the header gave up, so nothing below it moves */
    syncGap() {
      const s = this.section;
      if (!s.classList.contains('is-compact') || !this.fullH) { s.style.marginBottom = ''; return; }
      s.style.marginBottom = `${this.fullH - s.offsetHeight}px`;
    }
    open(item) {
      this.items.forEach((i) => { if (i !== item) this.close(i); });
      item.classList.add('is-open');
      item.querySelector('.vc-nav__link').setAttribute('aria-expanded', 'true');
    }
    close(item) {
      item.classList.remove('is-open');
      const l = item.querySelector('.vc-nav__link');
      l && l.setAttribute('aria-expanded', 'false');
    }
  });
}
if (!customElements.get('vc-drawer')) {
  customElements.define('vc-drawer', class extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.vc-drawer__panel');
      this.section = this.closest('.shopify-section');
      this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'Tab') {
          const f = [...this.panel.querySelectorAll('a[href], button, summary, input')].filter((el) => el.offsetParent !== null);
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });
    }
    open(opener) {
      clearTimeout(this.hideTimer);
      this.opener = opener; this.hidden = false; document.body.classList.add('vc-lock');
      // every opening starts at the top of the menu
      this.panel.scrollTop = 0;
      // the drawer lives inside the sticky header section (z-index 40): lift the section so the drawer
      // covers fixed bars that sit above the header, like the product page's sticky add-to-cart bar (45)
      this.section && this.section.classList.add('vc-drawer-open');
      opener && opener.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => { this.classList.add('is-open'); this.panel.focus(); });
    }
    close() {
      if (this.hidden) return;
      this.classList.remove('is-open'); document.body.classList.remove('vc-lock');
      this.opener && this.opener.setAttribute('aria-expanded', 'false');
      this.hideTimer = setTimeout(() => {
        this.hidden = true;
        // fold the groups once the panel is out of sight, so the next opening shows the whole menu
        this.querySelectorAll('details[open]').forEach((d) => { d.open = false; });
        this.section && this.section.classList.remove('vc-drawer-open');
        this.opener && this.opener.focus({ preventScroll: true });
      }, 280);
    }
  });
}
